import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.rolle-externer-ansprechpartner-festlegen';
import * as api from '../../../clients/benutzerverwaltung';

@Injectable()
export class BenutzerverwaltungRolleExternerAnsprechpartnerFestlegenEffects {

    RolleExternerAnsprechpartnerFestlegen$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_ROLLE_EXTERNER_ANSPRECHPARTNER_FESTLEGEN),
        mergeMap((x: ac.PostRolleExternerAnsprechpartnerFestlegenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postRolleExternerAnsprechpartnerFestlegen(x.rolleExternerAnsprechpartnerFestlegenRequest).pipe(
                map((result: any) => {
                    return new ac.PostRolleExternerAnsprechpartnerFestlegenErfolgreichAction(result, x.rolleExternerAnsprechpartnerFestlegenRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostRolleExternerAnsprechpartnerFestlegenFehlerAction(error, x.rolleExternerAnsprechpartnerFestlegenRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.RollenCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.RollenCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.RollenCommandService);
        }
        return this.service;
    }
}
